import React from 'react';
import './Callout.scss';

type CalloutProps = {
  text: string;
  isWarning?: boolean;
};

const Callout = ({ text, isWarning = false }: CalloutProps): JSX.Element => {
  const calloutClass = isWarning ? 'callout warning' : 'callout';
  const calloutInnerClass = isWarning
    ? 'callout-inner warning-inner cms'
    : 'callout-inner cms';
  return (
    <>
      {text && (
        <div className={calloutClass}>
          <div className={calloutInnerClass}>
            <span>{text}</span>
          </div>
        </div>
      )}
    </>
  );
};

export default Callout;
